import type { KnowledgeArticleTranslations } from './articles.types';

export const KNOWLEDGE_BASE_ARTICLES_BN: KnowledgeArticleTranslations = {
  pickup: {
    title: 'সংগ্রহ অর্ডার',
    summary: "পিকআপ অর্ডার তৈরি, ট্র্যাক এবং পরিচালনা করুন।",
    content:
      'সংগ্রহ অর্ডার আপনার সাইটগুলো থেকে বর্জ্য সংগ্রহের সময়সূচি নির্ধারণ করতে ব্যবহৃত হয়। সাইডবার থেকে «সংগ্রহ অর্ডার» খুলুন যাতে নতুন অর্ডার তৈরি, তালিকা দেখা বা অবস্থা ট্র্যাক করা যায়।\n\nধাপে ধাপে নির্দেশনার জন্য নিচে একটি নির্দেশিকা বেছে নিন।',
  },
  'view-pickup-orders-list': {
    title: "পিকআপ অর্ডার তালিকা দেখুন",
    summary: "অর্ডার টেবিল খুলুন, অনুসন্ধান করুন এবং পিকআপ অনুরোধ ব্রাউজ করুন।",
    content:
      "1. সাইডবারে «পিকআপ অর্ডার» খুলুন।\n\n2. প্রধান টেবিলে আপনার প্রতিষ্ঠানের পিকআপ অর্ডার ID, সংগ্রহ স্থান, স্ট্যাটাস ও তারিখসহ দেখায়।\n\n3. ID বা সংগ্রহ স্থান দিয়ে অর্ডার খুঁজতে টেবিলের উপরের সার্চ বক্স ব্যবহার করুন।\n\n4. আরও সারি দেখতে টেবিল স্ক্রল করুন এবং নিচের পেজিনেশন ব্যবহার করুন।\n\nটিপ: স্ট্যাটাস চিপ ও তারিখ ফিল্টার ফলাফল সীমিত করে — সংশ্লিষ্ট গাইড দেখুন।",
  },
  'create-pickup-order-outlet': {
    title: 'নতুন সংগ্রহ অর্ডার তৈরি করুন',
    summary: "বর্জ্য পিকআপ নির্ধারণের ধাপে ধাপে গাইড।",
    content:
      '1. সাইডবার থেকে «সংগ্রহ অর্ডার» খুলুন তারপর «সংগ্রহ অর্ডার তৈরি করুন» (অথবা সংগ্রহ অর্ডার পৃষ্ঠায় + বোতামে ক্লিক করুন)।\n\n2. অর্ডারের বিবরণ:\n   • উপাদানের ধরন (আবশ্যক) — বর্জ্যের শ্রেণি ও পরিমাপের একক স্বয়ংক্রিয়ভাবে পূরণ হয়।\n\n3. অবস্থান ও কন্টেইনার:\n   • সংগ্রহ স্থান (আবশ্যক)\n   • নির্বাচিত স্থানের কন্টেইনার\n   • পূরণের স্তর — পূর্ণ, তিন চতুর্থাংশ, অর্ধেক, বা এক চতুর্থাংশ পূর্ণ\n\n4. «সংরক্ষণ করুন»-এ ক্লিক করুন। অর্ডারটি তালিকায় «অপেক্ষমাণ» অবস্থায় দেখা যাবে।',
  },
  material: {
    title: 'উপাদান',
    summary: "পিকআপ অর্ডারের জন্য উপাদানের ধরন যোগ, সম্পাদনা ও পরিচালনা করুন।",
    content:
      'উপাদানের ধরন যোগ ও সম্পাদনা করার পদ্ধতি জানতে নিচে থেকে একটি নির্দেশিকা বেছে নিন।',
  },
  'add-material-type': {
    title: 'উপাদানের ধরন যোগ করুন',
    summary: "পিকআপ অর্ডারের জন্য বর্জ্য উপাদানের ধরন নিবন্ধন করুন।",
    content:
      '1. সাইডবার থেকে «পুনর্ব্যবহার» খুলুন তারপর «উপাদানের ধরন»।\n\n2. «উপাদান যোগ করুন» (উপরে ডানে) ক্লিক করুন।\n\n3. উপাদানের নাম, বিভাগ ও পরিমাপের একক লিখুন (যেমন: কেজি, টন, ব্যাগ)।\n\n4. «সংরক্ষণ করুন»-এ ক্লিক করুন। সংগ্রহ অর্ডার তৈরি করার সময় উপাদানটি উপলব্ধ হবে।',
  },
  container: {
    title: 'কন্টেইনার',
    summary: "বর্জ্য কন্টেইনার যোগ, পরিচালনা ও ট্র্যাক করুন।",
    content:
      'কন্টেইনার পরিচালনার পদ্ধতি জানতে নিচে থেকে একটি নির্দেশিকা বেছে নিন।',
  },
  'add-container': {
    title: 'নতুন কন্টেইনার যোগ করুন',
    summary: "সংগ্রহ স্থানে একটি বর্জ্য কন্টেইনার নিবন্ধন করুন।",
    content:
      '1. সাইডবার থেকে «কন্টেইনার» খুলুন তারপর «কন্টেইনার তালিকা»।\n\n2. «কন্টেইনার যোগ করুন» (উপরে ডানে) ক্লিক করুন।\n\n3. কন্টেইনারের বিবরণ পূরণ করুন: নাম, উপাদানের ধরন, সংগ্রহ স্থান, অবস্থা ও অন্যান্য প্রয়োজনীয় ক্ষেত্র।\n\n4. «সংরক্ষণ করুন»-এ ক্লিক করুন। কন্টেইনারটি তালিকায় দেখা যাবে এবং সংগ্রহ অর্ডার তৈরি করার সময় নির্বাচন করা যাবে।',
  },
  'collection-site': {
    title: 'সংগ্রহ স্থান',
    summary: "বর্জ্য সংগ্রহ স্থান যোগ, সম্পাদনা ও পরিচালনা করুন।",
    content:
      'সংগ্রহ স্থান পরিচালনার পদ্ধতি জানতে নিচে থেকে একটি নির্দেশিকা বেছে নিন।',
  },
  'add-collection-site': {
    title: 'নতুন সংগ্রহ স্থান যোগ করুন',
    summary: "যেখানে বর্জ্য সংগ্রহ হয় এমন একটি স্থান তৈরি করুন।",
    content:
      '1. সাইডবার থেকে «কন্টেইনার» খুলুন তারপর «সংগ্রহ স্থান»।\n\n2. «স্থান যোগ করুন» (উপরে ডানে) ক্লিক করুন।\n\n3. স্থানের নাম, ঠিকানা ও প্রয়োজনীয় বিবরণ লিখুন।\n\n4. «সংরক্ষণ করুন»-এ ক্লিক করুন। এখন আপনি কন্টেইনারগুলো এই স্থানের সাথে যুক্ত করতে এবং সংগ্রহ অর্ডার ফর্মে নির্বাচন করতে পারবেন।',
  },

  truck: {
    title: 'ট্রাক',
    summary: "যানবাহন যোগ করুন, ফ্লিট স্ট্যাটাস বুঝুন এবং ট্রাক পরিচালনা করুন।",
    content:
      'যানবাহন বহর পরিচালনার পদ্ধতি জানতে নিচে থেকে একটি নির্দেশিকা বেছে নিন।',
  },
  'add-vehicle': {
    title: 'যানবাহন যোগ করুন',
    summary: "সম্পূর্ণ বিবরণসহ নতুন ট্রাক বা ফ্লিট যানবাহন নিবন্ধন করুন।",
    content:
      '1. সাইডবার থেকে «ট্রাক» খুলুন যাতে «বহর পরিচালনা»-তে প্রবেশ করা যায়।\n\n2. «যানবাহন যোগ করুন» (উপরে ডানে) ক্লিক করুন।\n\n3. ফর্ম পূরণ করুন:\n   • নম্বর প্লেট (আরবি ও ইংরেজি)\n   • যানবাহনের নাম (আবশ্যক)\n   • ধারণক্ষমতা ও ধারণক্ষমতার একক\n   • যানবাহনের ধরন, মডেল, VIN, খালি ওজন ও জ্বালানি খরচ\n   • অবস্থা — যানবাহন বরাদ্দের জন্য প্রস্তুত হলে «উপলব্ধ» নির্বাচন করুন\n\n4. «সংরক্ষণ করুন»-এ ক্লিক করুন। যানবাহনটি বহর তালিকায় দেখা যাবে।',
  },
  driver: {
    title: 'চালক',
    summary: "চালক নিবন্ধন, প্রোফাইল দেখা এবং ট্রাক অ্যাসাইনমেন্ট পরিচালনা করুন।",
    content:
      'চালক পরিচালনার পদ্ধতি জানতে নিচে থেকে একটি নির্দেশিকা বেছে নিন।',
  },
  'add-driver': {
    title: 'চালক যোগ করুন',
    summary: "লাইসেন্স ও ব্যক্তিগত বিবরণসহ চালক অ্যাকাউন্ট তৈরি করুন।",
    content:
      '1. সাইডবার থেকে «চালক» খুলুন।\n\n2. «চালক যোগ করুন» (উপরে ডানে) ক্লিক করুন।\n\n3. অ্যাকাউন্ট বিভাগ: ইমেইল, পাসওয়ার্ড ও তার নিশ্চিতকরণ।\n\n4. ব্যক্তিগত বিভাগ: নাম, ফোন নম্বর, লিঙ্গ, জাতীয়তা ও অন্যান্য।\n\n5. চালক ও যানবাহন বিভাগ: ড্রাইভিং লাইসেন্স নম্বর, মেয়াদোত্তীর্ণের তারিখ ও যানবাহন নিবন্ধন নম্বর।\n\n6. «সংরক্ষণ করুন»-এ ক্লিক করুন। চালকটি তালিকায় দেখা যাবে।',
  },
  'understanding-notifications': {
    title: 'বিজ্ঞপ্তি',
    summary: "প্ল্যাটফর্ম সতর্কতা সক্রিয়, পড়া ও পরিচালনা করার উপায়।",
    content:
      'ব্রাউজার বিজ্ঞপ্তি সক্রিয় করুন:\nঅনুমতির অনুরোধ এলে «অনুমতি দিন»-এ ক্লিক করুন যাতে অ্যাপের বাইরে অর্ডার ও প্ল্যাটফর্ম আপডেট পাওয়া যায়।\n\nবিজ্ঞপ্তি দেখুন:\n1. উপরের বারে ঘণ্টার আইকনে ক্লিক করুন।\n2. প্যানেলে অপঠিত বিজ্ঞপ্তি শিরোনাম, বার্তা ও সময়সহ দেখায়।\n3. কোনো বিজ্ঞপ্তিতে ক্লিক করে পঠিত হিসেবে চিহ্নিত করুন।\n4. «সব পঠিত হিসেবে চিহ্নিত করুন» ব্যবহার করে সব অপঠিত বিজ্ঞপ্তি একসাথে মুছে ফেলুন।\n\nগুরুত্বপূর্ণ:\n• ঘণ্টায় দেখানো সংখ্যা অপঠিত বিজ্ঞপ্তির সংখ্যা বোঝায়।',
  },
  'pickup-order-statuses': {
    title: 'সংগ্রহ অর্ডারের অবস্থা',
    summary: "অপারেশনের মধ্য দিয়ে যাওয়ার সময় প্রতিটি অর্ডার স্ট্যাটাসের অর্থ।",
    content:
      'আপনি «সংগ্রহ অর্ডার» তালিকা থেকে বর্তমান অবস্থা দেখতে পারেন। অর্ডারের অগ্রগতির সাথে অবস্থা স্বয়ংক্রিয়ভাবে আপডেট হয়।\n\n• অপেক্ষমাণ — অর্ডার তৈরি হয়েছে এবং প্রক্রিয়াকরণ বা বরাদ্দের অপেক্ষায়।\n• পরিবহনে — বর্জ্য সংগ্রহ বা সরবরাহ চলছে।\n• সম্পন্ন — অর্ডার সফলভাবে সম্পন্ন হয়েছে।\n• বাতিল — অর্ডার বাতিল করা হয়েছে এবং সম্পন্ন হবে না।',
  },
  'filter-pickup-orders-by-date': {
    title: 'তারিখ অনুযায়ী অর্ডার ফিল্টার করুন',
    summary: "নির্দিষ্ট তারিখ সীমার মধ্যে অর্ডার খুঁজুন।",
    content:
      '1. সাইডবার থেকে «সংগ্রহ অর্ডার» খুলুন।\n\n2. «তারিখ অনুযায়ী ফিল্টার» বিভাগে যান।\n\n3. শুরু ও শেষ তারিখ নির্ধারণ করুন।\n\n4. তালিকা ফিল্টার করতে «তারিখ প্রয়োগ করুন»-এ ক্লিক করুন।\n\n5. ফিল্টার সরাতে ও ডিফল্ট দৃশ্যে ফিরতে «তারিখ মুছুন»-এ ক্লিক করুন।',
  },
  'container-fill-level': {
    title: 'কন্টেইনার পূরণের স্তর',
    summary: "কন্টেইনারের জন্য সঠিক ভর্তির মাত্রা বেছে নেওয়ার উপায়।",
    content:
      '«সংগ্রহ অর্ডার তৈরি করুন» ফর্মে কন্টেইনার নির্বাচন করলে পূরণের স্তর বাধ্যতামূলক হয়ে যায়।\n\nউপলব্ধ বিকল্প:\n• পূর্ণ — কন্টেইনার সম্পূর্ণভাবে পূর্ণ\n• তিন চতুর্থাংশ পূর্ণ — প্রায় ৭৫% পূর্ণ\n• অর্ধেক পূর্ণ — প্রায় ৫০% পূর্ণ\n• এক চতুর্থাংশ পূর্ণ — প্রায় ২৫% পূর্ণ\n\nপ্রকৃত অবস্থার নিকটতম স্তর বেছে নিন যাতে কার্যক্রম ও চালকরা ভালো পরিকল্পনা করতে পারেন।',
  },
  'container-statuses': {
    title: 'কন্টেইনারের অবস্থা',
    summary: "প্রতিটি কন্টেইনার স্ট্যাটাসের অর্থ এবং কখন ব্যবহার করবেন।",
    content:
      '«কন্টেইনার তালিকা» থেকে কন্টেইনার যোগ বা সম্পাদনা করার সময় অবস্থা নির্ধারণ বা পর্যালোচনা করা যায়।\n\n• সংগ্রহের জন্য প্রস্তুত — কন্টেইনার প্রস্তুত এবং বর্জ্য সংগ্রহ করা যায়।\n• সংগ্রহের অপেক্ষায় — সংগ্রহ নির্ধারিত বা কার্যক্রমের অপেক্ষায়।\n• খালি — সংগ্রহের মতো কোনো বর্জ্য নেই।\n• রক্ষণাবেক্ষণে — কন্টেইনার সাময়িকভাবে সেবার বাইরে।\n• প্রস্তুতিতে — কন্টেইনার সেটআপ করা হচ্ছে।\n• নিষ্ক্রিয় — কন্টেইনার বর্তমানে ব্যবহারে নেই।',
  },
  'print-container-qr': {
    title: 'কন্টেইনার QR কোড প্রিন্ট করুন',
    summary: "মাঠে ব্যবহারের জন্য QR লেবেল তৈরি ও প্রিন্ট করুন।",
    content:
      '1. «কন্টেইনার» ← «কন্টেইনার তালিকা» খুলুন।\n\n2. তালিকায় কন্টেইনার খুঁজুন।\n\n3. সারিতে QR আইকনে ক্লিক করুন।\n\n4. প্রিন্ট ডায়ালগ থেকে লেবেল প্রিন্ট করুন।\n\nলেবেলটি স্থানে কন্টেইনারে লাগান যাতে শনাক্তকরণ ও মাঠে স্ক্যানিং সহজ হয়।',
  },
  'edit-material-type': {
    title: 'উপাদানের ধরন সম্পাদনা বা মুছুন',
    summary: "রিসাইক্লিং সেটিংস থেকে উপাদানের ধরন আপডেট বা সরান।",
    content:
      '1. «পুনর্ব্যবহার» ← «উপাদানের ধরন» খুলুন।\n\n2. সম্পাদনার জন্য: সম্পাদনা আইকনে ক্লিক করুন, বিবরণ পরিবর্তন করুন, তারপর «সংরক্ষণ করুন»-এ ক্লিক করুন।\n\n3. মুছে ফেলার জন্য: মুছুন আইকনে ক্লিক করুন, তারপর কার্যক্রম নিশ্চিত করুন।\n\nসতর্কতা: সক্রিয় সংগ্রহ অর্ডারের সাথে যুক্ত উপাদানের ধরন মুছবেন না। প্রথমে সেই অর্ডারগুলো সম্পন্ন বা আপডেট করুন।',
  },
  'edit-or-delete-container': {
    title: 'কন্টেইনার সম্পাদনা বা মুছুন',
    summary: "তালিকা থেকে কন্টেইনার আপডেট বা সরান।",
    content:
      '1. «কন্টেইনার» ← «কন্টেইনার তালিকা» খুলুন।\n\n2. সম্পাদনার জন্য: সম্পাদনা আইকনে ক্লিক করুন, বিবরণ পরিবর্তন করুন, তারপর «সংরক্ষণ করুন»-এ ক্লিক করুন।\n\n3. মুছে ফেলার জন্য: মুছুন আইকনে ক্লিক করুন, তারপর কার্যক্রম নিশ্চিত করুন।\n\nসতর্কতা: কন্টেইনার সংগ্রহ অর্ডারের সাথে যুক্ত হতে পারে। মুছে ফেলার আগে নিশ্চিত করুন।',
  },
  'edit-or-delete-collection-site': {
    title: 'সংগ্রহ স্থান সম্পাদনা বা মুছুন',
    summary: "সংগ্রহ স্থান আপডেট বা সরান।",
    content:
      '1. «কন্টেইনার» ← «সংগ্রহ স্থান» খুলুন।\n\n2. স্থান কার্ডে «সম্পাদনা» বা «মুছুন»-এ ক্লিক করুন।\n\n3. অনুরোধ করলে মুছে ফেলা নিশ্চিত করুন।\n\nসতর্কতা: স্থান কন্টেইনার ও সংগ্রহ অর্ডারের সাথে যুক্ত হতে পারে। মুছে ফেলার আগে সংযোগ পর্যালোচনা করুন।',
  },
  'truck-statuses': {
    title: 'যানবাহনের অবস্থা',
    summary: "প্রতিটি ফ্লিট যানবাহন স্ট্যাটাসের অর্থ এবং কখন ব্যবহার করবেন।",
    content:
      'প্রতিটি যানবাহনের অবস্থা «বহর পরিচালনা» তালিকায় দেখানো হয়। যোগ বা সম্পাদনা করার সময় এটি আপডেট করা যায়।\n\n• উপলব্ধ — যানবাহন চালক বা ভ্রমণের জন্য বরাদ্দের জন্য প্রস্তুত।\n• অনুপলব্ধ — যানবাহন বর্তমানে ব্যবহার করা যায় না।\n• পরিবহনে — যানবাহন রাস্তায়।\n• লোডিং / আনলোডিং — যানবাহন লোডিং বা আনলোডিং স্থানে।\n• রক্ষণাবেক্ষণে — যানবাহন মেরামত বা সেবায়।\n\nপরামর্শ: সাময়িক বন্ধ থাকলে «অনুপলব্ধ» বা «রক্ষণাবেক্ষণে» রাখুন, মুছবেন না।',
  },
  'view-driver-details': {
    title: 'চালকের বিবরণ দেখুন',
    summary: "চালকের প্রোফাইল, লাইসেন্স তথ্য এবং নিয়োজিত ট্রাক খুলুন।",
    content:
      '1. সাইডবার থেকে «চালক» খুলুন।\n\n2. তালিকায় চালক খুঁজুন।\n\n3. বিবরণ খুলতে দেখুন (চোখ) আইকনে ক্লিক করুন।\n\n4. ডায়ালগে দেখায়: অ্যাকাউন্ট তথ্য, ব্যক্তিগত বিবরণ, লাইসেন্স তথ্য ও বরাদ্দকৃত ট্রাক যদি থাকে।\n\n5. সম্পাদনার জন্য: ডায়ালগে «সম্পাদনা»-তে ক্লিক করুন, অথবা সারির ক্রিয়া মেনু ব্যবহার করুন।\n\nট্রাক «বরাদ্দ নয়» দেখালে ক্রিয়া মেনু থেকে «ট্রাকে বরাদ্দ করুন» বেছে নিন।',
  },
  'edit-or-delete-vehicle': {
    title: 'যানবাহন সম্পাদনা বা মুছুন',
    summary: "যানবাহনের বিবরণ আপডেট করুন বা ফ্লিট থেকে ট্রাক সরান।",
    content:
      'যানবাহন সম্পাদনা:\n1. «ট্রাক» ← «বহর পরিচালনা» খুলুন।\n2. সারিতে সম্পাদনা আইকনে ক্লিক করুন, অথবা বিবরণ খুলে «সম্পাদনা» বেছে নিন।\n3. ক্ষেত্র পরিবর্তন করুন ও «সংরক্ষণ করুন»-এ ক্লিক করুন।\n\nযানবাহন মুছুন:\n1. সারিতে মুছুন আইকনে ক্লিক করুন, অথবা বিবরণ থেকে মুছুন।\n2. মুছে ফেলা নিশ্চিত করুন।\n\nসতর্কতা: যানবাহন চালকের কাছে বরাদ্দ বা সক্রিয় ভ্রমণের সাথে যুক্ত থাকলে মুছে ফেলা কার্যক্রমে প্রভাব ফেলতে পারে।',
  },
  'edit-or-delete-driver': {
    title: 'চালক সম্পাদনা ও ট্রাক বরাদ্দ',
    summary: "চালকের তথ্য আপডেট করুন এবং ট্রাক অ্যাসাইনমেন্ট পরিচালনা করুন।",
    content:
      'চালকের বিবরণ সম্পাদনা:\n1. «চালক» খুলুন।\n2. সারির ক্রিয়া মেনু থেকে «চালক সম্পাদনা» বেছে নিন।\n3. বিবরণ পরিবর্তন করুন ও «সংরক্ষণ করুন»-এ ক্লিক করুন।\n\nবিকল্প: দেখুন আইকনে ক্লিক করুন তারপর বিবরণ থেকে «সম্পাদনা» বেছে নিন।\n\nট্রাক বরাদ্দ:\n1. ক্রিয়া মেনু থেকে «ট্রাকে বরাদ্দ করুন» বেছে নিন।\n2. উপলব্ধ ট্রাক (যার চালক বরাদ্দ নেই) বেছে নিয়ে নিশ্চিত করুন।\n\nবরাদ্দ বাতিল:\n1. ক্রিয়া মেনু থেকে «ট্রাক থেকে বরাদ্দ বাতিল» বেছে নিন (শুধু বরাদ্দ থাকলে দেখা যায়)।\n2. কার্যক্রম নিশ্চিত করুন।',
  },
};
